import { OS_RESULT_WINDOW } from 'src/constants';

const isPositiveInt = (n: number): boolean => Number.isFinite(n) && Number.isInteger(n) && n > 0;

export const remainingInWindow = (start: number): number => {
  if (!Number.isFinite(start)) return 0;
  return Math.max(0, OS_RESULT_WINDOW - start);
};

export const clampQuerySize = (perPage: number, start: number): number => {
  if (!isPositiveInt(perPage)) return 0;
  if (!Number.isFinite(start)) return 0;
  return Math.min(perPage, remainingInWindow(start));
};

export const pageRange = (page: number, perPage: number, total: number): { from: number; to: number } => {
  if (!isPositiveInt(page) || !isPositiveInt(perPage) || !Number.isFinite(total) || total <= 0) {
    return { from: 0, to: 0 };
  }
  // Defensive: an over-range page (start beyond total) would otherwise produce
  // from > to, which renders nonsense like "Showing 23953-10000 of 10000".
  // Callers should clamp page first, but treat this util as the safety net.
  if ((page - 1) * perPage >= total) return { from: 0, to: 0 };
  const from = (page - 1) * perPage + 1;
  const to = Math.min(page * perPage, total);
  return { from, to };
};
